import * as utils from '../utils/utils.js';
import * as userPerms from '../utils/userPerms.js';

export default class SignIn {
    constructor($scope) {
        this.$scope = $scope;
        this.user = utils.getCurrentUser();
        this.siteSettings = siteSettings;

        this.showSignInControls = false;

        if (this.siteSettings.enableOrgSignIn) {
            this.displayEmailForm = false;
            this.displayUserTypeSelect = true;
            this.displayPrivacyInfo = false;
        } else {
            this.displayInputFields(false);
        }

        this.email = this.user !== null ? this.user._au : null;
        if (this.email) {
            this.fullName = this.user._dn;
        }

        this.latestClickedBtnText = '';
        this.authSuccessful = false;
        this.accessDenied = false;
        this.isEmbed = window.location.search.match(/&embed/i) || pageContext.isEmbed;
        this.signInStarted = false;
    }

    $onInit() {
        this.fetchPageContext();
    }

    fetchPageContext() {
        let reqUrl = `/events/pagecontext/signin/${pageContext.objectId}`;
        if (pageContext.accessType.requireFedAuth) {
            if (userPerms.aadAuthenticated(this.user)) {
                reqUrl = `/events/pagecontext/int/signin/${pageContext.objectId}`;
            } else {
                window.location.href = utils.getSignInUrl(true);
            }
        }

        fetch(reqUrl, {
            credentials: 'omit'
        })
            .then(response => {
                utils.setUserLocation(response.headers);

                if (response.status === 400) {
                    // Something is wrong and we'll proceed to error 400 page.
                    utils.log('signin', 'Bad request, redirecting to error page', false, 3);
                    window.location.href = `/Home/Error?statusCode=400&embed=${this.isEmbed}`;
                } else if (response.status === 403) {
                    // This means it's an invites-only-event.
                    // redirect to error page
                    let errorMsg =
                        'You are not authorized to view this webcast. Access is granted on individual basis by the event admin.';
                    window.location.href = `/Home/Error?statusCode=401&embed=${
                        this.isEmbed
                    }&additionalDetails=${encodeURIComponent(errorMsg)}`;
                } else if (response.status === 404) {
                    // Event does not exist/is deleted - redirect to error page
                    window.location.href = `/Home/Error?statusCode=404&embed=${this.isEmbed}`;
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (!data || !data.event) {
                    return;
                } else {
                    //utils.log('sign in - webcast data', JSON.stringify(data), true, 1);
                    this.setupControls(data.event, data.eAs);
                }
            });
    }

    setupControls(event, admins) {
        this.$scope.$apply(() => {
            this.$scope.event = event;

            // Toggle sign in elements based on event settings
            if (this.isEmbed) {
                document.getElementById('pinCodeArrow').classList.add('hide');
            }

            if (pageContext.pinError && userPerms.anonAuthenticated(event.accessKey, this.user)) {
                this.showSignInControls = false;
                document.getElementById('pinCodeArea').classList.remove('hide');
            } else if (
                event.signInRequiredForExternalUsers &&
                !userPerms.aadAuthenticated(this.user) &&
                !userPerms.anonAuthenticated(event.accessKey, this.user)
            ) {
                this.showSignInControls = true;
            } else if (event.eventAccessType.requirePin) {
                if (userPerms.allowedToSeeTechnicianLinks(this.user)) {
                    window.location.href = pageContext.returnUrl;
                } else if (userPerms.hasElevatedEventPermissions(this.user, admins)) {
                    this.setAdminPINAuth(event.accessKey);
                } else {
                    document.getElementById('pinCodeArea').classList.remove('hide');
                }
            } else {
                // If the logic fails (has never happened though ;) ), at least show the standard sign in controls
                this.showSignInControls = true;
            }
        });

        // Hide global sign in/out controls on this sign in page
        utils.hideElement(document.getElementById('vcl-si-lnk'));
        utils.hideElement(document.getElementById('vcl-so-lnk'));
    }

    authVolvoCars() {
        document.location =
            '/Account/ExternalLogin?returnUrl=' + encodeURIComponent(pageContext.returnUrl);
    }

    submitEmailForm() {
        if (this.signInStarted) {
            return;
        } else {
            this.signInStarted = true;
            this.fullName = this.fullName.trim();
            this.company = this.company ? this.company.trim() : '';
            this.email = this.email.trim();
            this.storeUserInfoAndSignIn(this.fullName, this.email, this.company);
        }
    }

    storeUserInfoAndSignIn(name, email, company) {
        let enterPIN =
            this.$scope.event.eventAccessType.requirePin &&
            !userPerms.pinAuthenticated(this.$scope.event.accessKey);

        this.setAnonAuth(enterPIN, name, email, company);
    }

    displayInputFields(fromEmailButton) {
        if (fromEmailButton)
            this.latestClickedBtnText = this.siteSettings.texts['SignIn_EmailButton'];

        this.displayEmailForm = true;
        this.displayUserTypeSelect = false;
        this.displayPrivacyInfo = true;
        let cdHide = document.querySelectorAll('.vl-countdown-hideable');
        if (cdHide !== undefined && cdHide !== null) {
            cdHide.forEach(elem => {
                if (!elem.classList.contains('hide')) elem.classList.add('hide');
            });
        }
    }

    changeAuthType() {
        this.displayEmailForm = false;
        this.displayUserTypeSelect = true;
        this.displayPrivacyInfo = false;
        let cdHide = document.querySelectorAll('.vl-countdown-hideable');
        if (cdHide !== undefined && cdHide !== null) {
            cdHide.forEach(elem => {
                if (elem.classList.contains('hide')) elem.classList.remove('hide');
            });
        }
        document.getElementById('pinCodeArea').classList.add('hide');
    }

    setAnonAuth(proceedWithPIN, name, email, company) {
        let ctrl = this;
        let reqUrl = '/events/int/setanonauth';

        utils.log('signin', 'Starting sign-in for user ' + email, false, 1);

        fetch(reqUrl, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: 'POST',
            body:
                'accessKey=' +
                this.$scope.event.accessKey +
                '&displayName=' +
                name +
                '&company=' +
                company +
                '&email=' +
                email,
            credentials: 'omit'
        }).then(function(response) {
            ctrl.displayEmailForm = false;
            ctrl.displayPrivacyInfo = false;
            ctrl.displayUserTypeSelect = false;
            ctrl.signInStarted = false;

            if (response.status === 403) {
                ctrl.authSuccessful = false;
                ctrl.accessDenied = true;
                utils.log('signin', 'Access denied for user ' + email, false, 1);
            } else {
                ctrl.authSuccessful = true;
                ctrl.accessDenied = false;
                utils.log(
                    'signin',
                    'Sign-in form submitted successfully for user ' + email,
                    false,
                    1
                );
            }

            ctrl.$scope.$apply();
        });
    }

    setAdminPINAuth(accessKey) {
        let ctrl = this;
        let reqUrl = '/events/int/adminpinauth';

        fetch(reqUrl, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: 'POST',
            body: 'accessKey=' + accessKey,
            credentials: 'include'
        }).then(function(response) {
            if (response.ok) {
                window.location.href = pageContext.returnUrl;
            } else {
                // Toggle PIN code field since user is obviously not admin
                ctrl.displayEmailForm = false;
                ctrl.displayUserTypeSelect = false;
                ctrl.displayPrivacyInfo = false;
                ctrl.$scope.$apply();
                document.getElementById('pinCodeArea').classList.remove('hide');
            }
        });
    }

    isOrgEmailUsed() {
        if (!this.email) return false;

        let domainMatch = this.email.match(/^.+@(.+)$/);
        if (domainMatch && domainMatch.length > 0) {
            let domain = domainMatch[1];
            let orgDomains = siteSettings.orgEmailDomains.split(',');
            if (orgDomains.find(_ => _.toLowerCase() === domain.toLowerCase())) {
                this.company = siteSettings.currentOrgName;
                return true;
            }
        }
        return false;
    }
}
